import { ConstantItems } from "@constants/shared";
import { FileItem } from "@models/fileprovider/FileItem";
import { Constants } from "@constants/shared";

export class ProviderRepo {
  static $inject = ["$http", "config"];

  constructor(
    private $http: angular.IHttpService,
    private config: ConstantItems,
    private configConstants: Constants
  ) {}
  getFiles() {
    return this.$http
      .get(`${this.config.fileUrl}/usernames`)
      .then((resp) => resp.data as String[]);
  }

  getPassword(username: string) {
    return this.$http
      .get(`${this.config.fileUrl}/password/${username}`)
      .then((resp) => resp.data as FileItem);
  }

  saveFile(username: string, file: FileItem) {
    return this.$http
      .post(`${this.config.fileUrl}/save/${username}`, file)
      .then((resp) => resp.data as String);
  }

  createFile(username: string, file: FileItem) {
    return this.$http
      .post(`${this.config.fileUrl}/create/${username}`, file)
      .then((resp) => resp.data as String);
  }

  checkFileReceived(provider: string, latestDate) {
    var bucket = Constants.getBucket(provider);
    return this.$http
      .get(
        `${this.config.fileUrl}/latestFile/${bucket}/${provider}/${latestDate}`
      )
      .then((resp) => resp.data as string);
  }

  rerunFiles(provider: string, latestDate) {
    var bucket = Constants.getBucket(provider);
    return this.$http
      .post(
        `${this.config.fileUrl}/rerunFiles/${bucket}/${provider}/${latestDate}`,
        {}
      )
      .then((resp) => resp.data as string);
  }

  processFilesFromDate(provider: string, fromDate: string) {
    var bucket = Constants.getBucket(provider);
    return this.$http
      .post(
        `${this.config.fileUrl}/process-files-from-date/${bucket}/${provider}/${fromDate}`,
        {}
      )
      .then((resp) => resp.data as string);
  }
}



// WEBPACK FOOTER //
// ./src/services/fileprovider.repo.ts